const setNodeRef = (ref, nodeRefs, node) => {
  if (ref && node?.identifier) {
    nodeRefs.current[node?.identifier] = ref;
  }
};

export default setNodeRef;
